import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { AppConfig } from './types';

/**
 * Branding and culture settings from `GET /api/app-config`.
 *
 * These come from `appsettings.json` and cannot change without a restart, so
 * the query never goes stale and never refetches. Anonymous, because the login
 * screen renders the title and the language list before sign-in.
 */

export const APP_CONFIG_QUERY_KEY = ['app-config'] as const;

export function useAppConfig() {
  return useQuery<AppConfig>({
    queryKey: APP_CONFIG_QUERY_KEY,
    queryFn: () => api.get<AppConfig>('/api/app-config'),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
}
